<template>
	<div class="row">
		<div class="col-md-6">
			<div class="form-group">
				<label>First Name</label>
				<b-form-input type="text" v-model="first_name"  v-on:keyup.enter="saveContactFn" ref="focusThis" lazy-formatter :formatter="Format.titleCase" />
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>Last Name</label>
				<b-form-input type="text" v-model="last_name" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>Title</label>
				<b-form-input type="text" v-model="position" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>Email</label>
			<b-form-input type="text" v-model="email_address"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.email"/>
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>Phone</label>
				<b-form-input type="text" v-model="phone"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.phone"/>
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>{{deliverableContactCompanyLabel(this.deliverableDetail.deliverable_template_id)}}</label>
				<b-form-input type="text" v-model="company_name"  v-on:keyup.enter="saveContactFn"/>
			</div>
		</div>
		<div class="col-md-6">
			<div class="form-group">
				<label>Region</label>
				<multiselect v-model="region" :options="allRegions" :multiple="false"></multiselect>
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<button class="btn btn-primary" type="button" @click="saveContactFn" data-dismiss="modal">Add</button>
			</div>
		</div>
	</div>

</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Format from "../../utility/Format";

export default {
	props: ["newContactName", "deliverableId"],
	data() {
		return {
			first_name: "",
			last_name: "",
			email_address: "",
			company_name: "",
			position: "",
			phone: "",
			region:"Local",
			Format,
		};
	},
	computed: {
		...mapGetters([
			"allRegions"
			,"deliverableDetail", "deliverableContactsLabel", "deliverableContactCompanyLabel"
		])
	},
	mounted() {
		let namePieces = this.$store.state.newContactName.split(" ");
		if (namePieces.length > 1) {
			this.last_name = Format.name(namePieces[namePieces.length - 1]);
			namePieces.pop();
		}
		this.first_name = Format.name(namePieces.join(" "));
	},
	methods: {
		focusMyElement() {
			this.$refs.focusThis.focus()
		},
		saveContactFn() {
			let first_name = this.first_name,
				last_name = this.last_name,
				email_address = this.email_address,
				phone = this.phone,
				company_name = this.company_name,
				region = this.region,
				position = this.position,
				deliverableId = this.$store.state.deliverableId;
			this.$store.dispatch("createContact", {
				first_name,
				last_name,
				email_address,
				phone,
				company_name,
				deliverableId,
				region,
				position
			});
			this.$bvModal.hide("createContactModal");
		}
	}
};
</script>

<style>
</style>